import { useModals } from 'almanac-ui/Modal'
import { Button } from 'components/Button/Button'
import { LocationPickerModal, LocationPickerModalProps } from './LocationPickerModal'
import { ChevronRight } from 'almanac-ui/icons/12'
import Styles from './LocationPicker.module.scss'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { More } from 'almanac-ui/icons/16'
import { IconButton } from 'components/IconButton/IconButton'

export type ActionType = 'copy' | 'move' | 'create'

export interface Props {
  folderName: string
  locationPickerProps: LocationPickerModalProps
}

export const LocationPickerModalButton = ({ folderName, locationPickerProps }: Props) => {
  const { openModal } = useModals()

  return (
    <DropdownTrigger placement="bottom-end" popoverClassName={Styles.morePopover}>
      <IconButton variant="tertiary" size="lg" icon={More} />
      {(close) => (
        <>
          <Button
            className={Styles.locationPickerButton}
            variant="tertiary"
            size="md"
            onPress={() => {
              close()
              openModal(
                LocationPickerModal,
                {
                  ...locationPickerProps,
                },
                { newStack: true },
              )
            }}
          >
            <span className={Styles.label}>Location</span>
            <div className={Styles.location}>
              <span>{folderName}</span>
              <ChevronRight />
            </div>
          </Button>
        </>
      )}
    </DropdownTrigger>
  )
}
